import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {actions, select} from './connectors';
import {
  SHOPPING_CART_CONFIRM,
  SHOPPING_CART_CONFIRM_DIRTY
} from '~/constants/NotificationConstants';
import MultiItemCart from '~/shared/components/MultiItemCart';
import {routerPropType} from '~/utils/propTypes';
import {formatPrice} from '~/utils/quote';
import {isEditDesignInCartMode} from '~/utils/url';
import {Button} from '@customink/pigment-react';

// metrics
import {metrics} from '~/vendor/metrics';
import {getCheckoutSummaryLink} from '../../constants/CheckoutLink';

import './index.scss';

const renderOrderSummary = (cartItems, subTotal) => {
  return (
    <div className="ndx-CartOverlay-body-orderSummary">
      <div className="ndx-CartOverlay-body-orderSummary-label">
        Total Styles
        <span className="ndx-CartOverlay-body-orderSummary-value">
          {cartItems.length}
        </span>
      </div>
      <div className="ndx-CartOverlay-body-orderSummary-label">
        Order Subtotal
        <span className="ndx-CartOverlay-body-orderSummary-value">
          {formatPrice(subTotal)}
        </span>
      </div>
    </div>
  );
};

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
export function CartOverlay(props) {
  const {
    alreadyAddedItems,
    cartItems,
    isDesignDirty,
    prompt,
    recentlyAddedItems,
    router,
    subTotal
  } = props;

  const navigateToCheckout = () => {
    metrics.fireEvent(
      'multi item cart',
      'cart icon',
      'review cart and checkout'
    );
    if (isDesignDirty) {
      const key = isEditDesignInCartMode()
        ? SHOPPING_CART_CONFIRM
        : SHOPPING_CART_CONFIRM_DIRTY;
      prompt({key: key});
    } else {
      window.location.href = getCheckoutSummaryLink();
    }
  };

  return (
    <div className="ndx-CartOverlay-container">
      <div className="ndx-CartOverlay-body">
        <div className="ndx-CartOverlay-body-content">
          <MultiItemCart
            alreadyAddedItems={alreadyAddedItems}
            recentlyAddedItems={recentlyAddedItems}
            router={router}
            shouldRenderNewLinePrice
          />
          {renderOrderSummary(cartItems, subTotal)}
        </div>
      </div>
      <div className="ndx-CartOverlay-footer">
        <Button
          size="large"
          className="cta-checkout"
          fullWidth
          onClick={navigateToCheckout}>
          Review Cart & Check Out
        </Button>
      </div>
    </div>
  );
}

const propTypes = {
  alreadyAddedItems: PropTypes.array,
  cartItems: PropTypes.array,
  isDesignDirty: PropTypes.bool,
  prompt: PropTypes.func,
  recentlyAddedItems: PropTypes.array,
  router: routerPropType,
  subTotal: PropTypes.number
};

CartOverlay.propTypes = propTypes;

CartOverlay.defaultProps = {
  alreadyAddedItems: [],
  cartItems: [],
  isDesignDirty: false,
  prompt: () => {},
  recentlyAddedItems: [],
  subTotal: 0
};

export default connect(select, actions)(CartOverlay);
